// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyDDtX-cv8IJDqhX2hIK5n9jYPXPS4MMMH0',
  authDomain: 'tamboro-3fc5b.firebaseapp.com',
  projectId: 'tamboro-3fc5b',
  storageBucket: 'tamboro-3fc5b.firebasestorage.app',
  messagingSenderId: '113088244642',
  appId: '1:113088244642:web:7b7281a209f232fc1b20fb',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
